import styled from 'styled-components';
export const Rows = styled.div.withConfig({
  displayName: "layout__Rows",
  componentId: "xf9k3p-0"
})(["display:flex;flex-direction:column;gap:24px;"]);
export const Columns = styled.div.withConfig({
  displayName: "layout__Columns",
  componentId: "xf9k3p-1"
})(["display:flex;flex-direction:row;gap:32px;"]);